/**
 * CollabV3TitleGroup 컴포넌트
 * @description 상세 첫 그룹 — 아티스트 · 운영 제공 배지, 제목, 참여자 줄(앱 `CollabDetailTitleGroup`).
 *   취소된 콜랩은 제목 아래에 사유를 붙인다(앱은 하단 바에 싣는 문구다 — 웹 하단에는 앱 버튼만 있어
 *   첫 화면에서 읽히도록 여기 둔다).
 * @example <CollabV3TitleGroup detail={detail} subject={subject} />
 */
import { memo } from "react";

import CollabV3Badge from "./CollabV3Badge";
import { collabV3DetailStyles } from "./CollabV3Detail.styles";
import type { CollabV3TitleGroupProps } from "./CollabV3Detail.types";
import CollabV3Participants from "./CollabV3Participants";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";

const CollabV3TitleGroup = memo<CollabV3TitleGroupProps>(({ detail, subject }) => {
  const styles = collabV3DetailStyles.info;
  const { artist, isOperatorProvided, badge, cancelReason } = detail;
  const hasBadges = artist !== null || isOperatorProvided;
  const isCancelled = badge === "CANCELLED";

  return (
    <div className={styles.root}>
      {hasBadges ? (
        <div className={styles.badges}>
          {artist ? <CollabV3Badge text={artist.name} tone="neutral" /> : null}
          {isOperatorProvided ? (
            <CollabV3Badge text={COLLAB_V3_COPY.operator} tone="highlight" />
          ) : null}
        </div>
      ) : null}
      <h1 className={styles.title}>{detail.title}</h1>
      {isCancelled ? (
        <p className={styles.cancelNotice}>
          {cancelReason ?? COLLAB_V3_COPY.bar.cancelledNoReason}
        </p>
      ) : null}
      <CollabV3Participants
        participants={detail.participants}
        totalCount={detail.participantsRowCount}
        subject={subject}
      />
    </div>
  );
});

CollabV3TitleGroup.displayName = "CollabV3TitleGroup";

export default CollabV3TitleGroup;
